<!--
    描述：基础模板配置入口页面
    时间：2020-05-18
    Created by yefan
-->
<template>
	<transition name="fade"
				mode="out-in">
		<router-view></router-view>
	</transition>
</template>

<script>
export default {
	name: 'Basic-template',
	data() {
		return {}
	},
	methods: {}
}
</script>

<style scoped lang="less">
</style>

